import React from 'react';
interface ProgressBarProps {
  current: number;
  total: number;
}
export function ProgressBar({
  current,
  total
}: ProgressBarProps) {
  const percentage = Math.min(100, Math.max(0, current / total * 100));
  return <div className="w-full" data-id="element-16">
      <div className="flex justify-between text-xs font-medium text-slate-500 mb-2 uppercase tracking-wider" data-id="element-17">
        <span data-id="element-18">Progresso</span>
        <span data-id="element-19">{Math.round(percentage)}%</span>
      </div>
      <div className="w-full bg-slate-100 rounded-full h-2.5 overflow-hidden" data-id="element-20">
        <div className="bg-slate-900 h-2.5 rounded-full transition-all duration-500 ease-out" style={{
        width: `${percentage}%`
      }} data-id="element-21" />
      </div>
    </div>;
}